import { Link } from "react-router-dom";

export default function ArticleCard() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="relative rounded-[32px] bg-foreground-950 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-[40%] relative">
              <div className="lg:absolute lg:inset-y-0 lg:-left-8 lg:w-[120%] pt-8 pb-8 lg:pt-0 lg:pb-0 px-8 lg:px-0">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylish%20person%20holding%20a%20tablet%20showing%20spreadsheet%20interface%20while%20standing%20in%20a%20bright%20modern%20fashion%20boutique%2C%20racks%20of%20clothing%20in%20background%20softly%20blurred%2C%20natural%20daylight%20from%20storefront%20windows%2C%20contemporary%20retail%20setting%2C%20editorial%20business%20photography%2C%20professional%20yet%20approachable%20mood&width=600&height=800&seq=article-card-v2-01&orientation=portrait"
                  alt="OOPBuy Spreadsheet guide featured"
                  className="w-full h-full max-h-[500px] lg:max-h-none rounded-[20px] object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-[60%] flex flex-col justify-center px-8 md:px-12 py-12 lg:py-16">
              <span className="text-7xl md:text-8xl text-background-100 select-none leading-none font-display italic">
                &ldquo;
              </span>

              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading leading-[1.2] mt-2">
                OOPBuy Spreadsheet Explained Simply (2026 Updated Version)
              </h2>

              <p className="mt-6 text-base md:text-lg text-background-300 leading-relaxed">
                OOPBuy spreadsheets have become an essential tool for modern dropshippers and e-commerce professionals. These structured data systems help you organize product information, compare supplier pricing, and track inventory across multiple platforms. Whether you are just getting started or scaling your operations, understanding how to leverage OOPBuy spreadsheet tools can dramatically improve your sourcing efficiency and profit margins.
              </p>

              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                To explore the full range of categories and tools available, visit the{" "}
                <Link to="/" className="text-accent-400 hover:text-accent-300 underline underline-offset-2 transition-colors">
                  OOPBuy Spreadsheet Hub
                </Link>{" "}
                where you can browse all 14 product categories and compare the best spreadsheet systems for your needs.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Link
                  to="/article/what-is-oopbuy-spreadsheet"
                  className="inline-flex items-center justify-center h-[52px] px-8 rounded-full bg-accent-400 text-foreground-950 text-sm font-semibold hover:bg-accent-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Read Full Guide
                </Link>
                <Link
                  to="/"
                  className="inline-flex items-center gap-1.5 text-sm text-background-400 hover:text-background-200 transition-colors"
                >
                  <i className="ri-arrow-left-line"></i>
                  Return to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}